import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'AppVideoPlayerContentButtonLayout',
  props: {
    id: {},
    collapse: {
      type: Boolean
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_content = _resolveComponent("ion-content");
      const _component_ion_popover = _resolveComponent("ion-popover");
      return _ctx.collapse ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_ion_button, {
        id: _ctx.id,
        shape: "round"
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_icon, {
          name: "ellipsis-vertical-outline",
          slot: "icon-only"
        })]),
        _: 1
      }, 8, ["id"]), _createVNode(_component_ion_popover, {
        trigger: _ctx.id,
        "show-backdrop": false
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_content, null, {
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "content")]),
          _: 3
        })]),
        _: 3
      }, 8, ["trigger"])], 64)) : _renderSlot(_ctx.$slots, "content", {
        key: 1
      });
    };
  }
});